export const initialForm = {
  from: '',
  to: '',
  customer: '',
};

export const USER_USAGE_REPORT_FORM = 'userUsageReport';

export const RESULT_COLUMN_NAMES = {
  user: { title: 'User', dataIndex: 'createdBy', width: '' },
  customer: { title: 'Customer or Group', dataIndex: 'customer', width: '' },
  searchType: { title: 'Search Type', dataIndex: 'searchType', width: '' },
  titleNumber: { title: 'Title Number', dataIndex: 'searchName', width: '' },
  searchDate: { title: 'Search Date', dataIndex: 'searchDate', width: '13rem' },
  totalAmount: { title: 'Total Amount', dataIndex: 'amount', width: '' },
  description: { title: 'Description', dataIndex: 'description', width: '' },
  searchParameters: {
    title: 'Search Parameters',
    dataIndex: 'searchDetails',
    width: '25rem',
  },
};
